import { render, staticRenderFns } from "./merge_component.vue?vue&type=template&id=199a0ee6&scoped=true&"
import script from "./merge_component.vue?vue&type=script&lang=js&"
export * from "./merge_component.vue?vue&type=script&lang=js&"
import style0 from "./merge_component.vue?vue&type=style&index=0&id=199a0ee6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a0ee6",
  null
  
)

/* custom blocks */
import block0 from "./merge_component.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports